<template>
  <div id="app" :class="{ intro: status === 'init' }">
    <SvgPixel />
    <TheHeader />
    <TheToolbar v-if="status === 'start'" :hide="hideToolbar" />

    <ModalIntro v-show="modals.intro" />
    <ModalCurrentTask v-show="modals.currentTask" />
    <ModalHowToPlay v-show="modals.howToPlay" />
    <ModalLevelStart v-show="modals.levelStart" />
    <ModalLevelFail v-show="modals.levelFail" />
    <ModalLevelFinish v-show="modals.levelFinish" />
    <ModalFormSend v-show="modals.formSend" />

    <portal-target class="character_modal" name="modal" />

    <div
      :class="[
        'main',
        {
          'main--intro': status === 'init',
          'main--game': status === 'start'
        }
      ]"
    >
      <div class="main__bg">
        <Animation
          :play="true"
          :loop="true"
          animation="gamepad1"
          class="gamepad-1"
        />
        <Animation
          :play="true"
          :loop="true"
          animation="gamepad2"
          class="gamepad-2"
        />

        <!-- <transition name="fade">
          <div v-if="status === 'init'">

          </div>
        </transition> -->

        <img src="./assets/img/main-bg.svg" class="main__bg__main" />
        <img src="./assets/img/plan-4.svg" class="main__bg__plan-4" />
        <img src="./assets/img/plan-3.svg" class="main__bg__plan-3" />
        <img src="./assets/img/plan-2.svg" class="main__bg__plan-2" />
        <img src="./assets/img/plan-1.svg" class="main__bg__plan-1" />
      </div>

      <div class="main__backdrop"></div>
      <ModalStart class="modal_start" />
      <Level class="main__game" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import "./assets/scss/style.scss";
import SvgPixel from "./components/SvgPixel.vue";

import TheHeader from "./components/TheHeader.vue";
import TheToolbar from "./components/TheToolbar.vue";

import Level from "./components/Level.vue";
import Animation from "./components/Animation";
import ModalCurrentTask from "./components/ModalCurrentTask";
import ModalHowToPlay from "./components/ModalHowToPlay";
import ModalStart from "./components/ModalStart";
import ModalIntro from "./components/ModalIntro";
import ModalLevelStart from "./components/ModalLevelStart";
import ModalLevelFail from "./components/ModalLevelFail";
import ModalLevelFinish from "./components/ModalLevelFinish";
import ModalFormSend from "./components/ModalFormSend";

export default {
  name: "App",
  components: {
    TheHeader,
    SvgPixel,
    TheToolbar,
    Level,
    Animation,
    ModalCurrentTask,
    ModalHowToPlay,
    ModalIntro,
    ModalLevelStart,
    ModalLevelFail,
    ModalLevelFinish,
    ModalStart,
    ModalFormSend
  },
  data() {
    return {
      mainSound: null,
      sounds: {
        fight: null,
        king: null,
        clicker: null,
        sackboy: null,
        lvlup: null,
        trophy: null,
        gameover: null
      },
      hideToolbar: false,
      vh: window.innerHeight * 0.01,
      pixels: {
        soundOn:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhiwy&pr=%random%&ptrc=b",
        soundOff:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhiwx&pr=%random%&ptrc=b"
      },
      links: {
        ps:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhixu&pr=%random%",
        sony:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhixv&pr=%random%",
        preorder:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhixs&pr=%random%"
      }
    };
  },
  computed: {
    ...mapState(["status", "isSoundOn", "levelId", "modals"])
  },
  methods: {
    ...mapMutations(["start", "toggleSound"]),

    initSounds() {
      this.mainSound = new Audio(require("./assets/sounds/main.mp3"));
      this.mainSound.loop = true;
      this.mainSound.volume = 0.4;

      this.sounds.fight = new Audio(require("./assets/sounds/swords.mp3"));
      this.sounds.clicker = new Audio(require("./assets/sounds/clicker.mp3"));
      this.sounds.king = new Audio(require("./assets/sounds/king.mp3"));
      this.sounds.sackboy = new Audio(require("./assets/sounds/sackboy.mp3"));
      this.sounds.lvlup = new Audio(require("./assets/sounds/lvlup.mp3"));
      this.sounds.trophy = new Audio(require("./assets/sounds/trophy.mp3"));
      this.sounds.gameover = new Audio(require("./assets/sounds/gameover.mp3"));
      this.sounds.teleport = new Audio(require("./assets/sounds/teleport.mp3"));
    },
    resizeHandler() {
      this.vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${this.vh}px`);
    },
    startWithSound(withSound) {
      this.start(withSound);
      if (withSound) {
        this.mainSound.play();
      }
      setTimeout(() => this.$store.commit("toggleModal", "intro"), 1000);
    },
    mediaHandler({ matches }) {
      this.$store.commit("setMobile", { mobile: matches });
    },
    scrollHandler() {
      let currentScrollLeft = document.getElementById("app").scrollLeft;
      this.hideToolbar = currentScrollLeft > 50 ? true : false;
    }
  },
  watch: {
    isSoundOn(soundOn) {
      if (soundOn) {
        this.mainSound.play();
      } else {
        this.mainSound.pause();
      }
    }
  },
  created() {
    this.resizeHandler = this.resizeHandler.bind(this);
    this.mediaHandler = this.mediaHandler.bind(this);

    this.vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${this.vh}px`);
    window.addEventListener("resize", this.resizeHandler);

    // check is mobile with media

    this.mediaQuery = window.matchMedia("(max-aspect-ratio: 3/2)");

    this.mediaHandler(this.mediaQuery);

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener("change", this.mediaHandler);
    } else {
      this.mediaQuery.addListener(this.mediaHandler);
    }
  },
  mounted() {
    document
      .getElementById("app")
      .addEventListener("scroll", this.scrollHandler);
    this.initSounds();

    this.$events.on("playSound", soundName => {
      if (this.isSoundOn) {
        this.sounds[soundName].currentTime = 0;
        this.sounds[soundName].play();
      }
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
    document
      .getElementById("app")
      .removeEventListener("scroll", this.scrollHandler);

    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener("change", this.mediaHandler);
    } else {
      this.mediaQuery.removeListener(this.mediaHandler);
    }
  }
};
</script>

<style lang="scss">
#app {
  overflow: auto;

  &.intro {
    overflow: hidden;
  }
}

.main {
  background: linear-gradient(#0300cc, #58fee0 100%) center;
  background-position: center center;
  background-size: auto 150%;
  height: vh(100);
  width: 100%;
  min-width: fit-content;
  position: relative;

  display: grid;

  &__backdrop {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    background-color: rgba(#000000, 0.3);
    transition: opacity 1s ease-out;
  }

  &__game {
    z-index: 3;
    height: 100%;
    position: relative;
    transition: transform 1s ease-out;
  }

  &__bg {
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: absolute;
    display: inherit;
    justify-self: flex-end;

    transition: transform 1s ease-out;

    & > img {
      position: absolute;
      justify-self: center;
      min-width: max(#{vh(200)}, 101vw);
      transition: inherit;
    }

    img.main__bg__plan-1 {
      bottom: vh(-13);
    }

    img.main__bg__plan-2 {
      bottom: vh(-6);
    }

    img.main__bg__plan-3 {
      bottom: vh(-3);
    }

    img.main__bg__plan-4 {
      min-width: max(#{vh(200)}, 134vw);
      bottom: vh(20);
    }

    img.main__bg__main {
      bottom: vh(-70);
      transform: translateY(0);
      z-index: 1;
    }
  }

  &--intro {
    background-position: center top;

    .main__backdrop {
      opacity: 0;
    }

    .main__bg {
      & > img {
        transform: translateY(vh(100));
      }

      img.main__bg__plan-3 {
        transform: translateY(vh(42));
      }

      img.main__bg__plan-4 {
        transform: translateY(vh(40));
      }

      img.main__bg__main {
        transform: translateY(calc(var(--vh, 1vh) * -70));
      }
    }

    .main__game {
      z-index: 0;
      transform: translateY(vh(80));
    }
  }

  &--game {
    .modal_start {
      opacity: 0;
      transform: translateY(-100%);
    }

    .animation {
      &.gamepad-1,
      &.gamepad-2 {
        /* transition: all 0.25s;
        opacity: 0; */
      }
    }
  }
}

.animation {
  &.gamepad-1 {
    width: 12%;
    height: 12%;
    min-width: auto;
    position: absolute;
    top: 30%;
    left: -15%;
    transform: none;
    animation: gamepad 16s linear infinite;
    z-index: 2;
  }

  &.gamepad-2 {
    width: 10%;
    height: 10%;
    min-width: auto;
    position: absolute;
    top: 18%;
    left: -11%;
    transform: none;
    animation: gamepad 18s linear 5s infinite;
    z-index: 2;
  }
}

@keyframes gamepad {
  0% {
    opacity: 1;
    transform: translateX(-5vw);
  }

  3% {
    opacity: 1;
  }

  97% {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translateX(135vw);
  }
}

.character_modal {
  .modal__inner {
    padding: 0;
    border: 1px solid #ffe1f3;
    box-shadow: none;

    .modal__close {
      background-color: $white;
    }
  }
}

@media (max-width: 768px) {
  .main__bg__main {
    display: none;
  }

  .main--intro {
    .main__backdrop {
      opacity: 1;
    }
  }

  @keyframes gamepad {
    0% {
      opacity: 1;
      transform: translateX(-5vw);
    }

    3% {
      opacity: 1;
    }

    97% {
      opacity: 1;
    }

    to {
      opacity: 0;
      transform: translateX(315vw);
    }
  }
}

@media (max-width: 550px) {
  .main--intro .main__bg {
    img.main__bg__plan-4 {
      opacity: 0;
    }
  }
}
</style>
